import { PushNotifications } from '@capacitor/push-notifications';
import { useContext, useEffect } from 'react';
import { DataContext } from '../context/DataContext';
import { Capacitor } from '@capacitor/core';
import { useLocation } from 'react-router-dom';

export const doRegister_PNs = ( user_name: string, app_token: string ) => {
  const send_fcm = ( fcm_token: any ) => {
    var myHeaders = new Headers();
    myHeaders.append( 'Content-Type', 'application/json' );
    myHeaders.append( 'Authorization', `Bearer ` + app_token );
    var requestOptions = {
      method: 'GET',
      headers: myHeaders
    };
    fetch(
      'https://intranet-backend.procuratio.com/api_v2/set_fcm.php?fcm=' +
      fcm_token.value +
      '&user=' +
      user_name,
      requestOptions
    ).catch( ( error ) => alert( 'FCM-Fehler ' + error ) );
  };
  PushNotifications.addListener( 'registration', send_fcm );
  PushNotifications.addListener( 'registrationError', ( error ) => {
    console.log( 'doRegister FEHLER', error );
  } );
  PushNotifications.register();
};

export function PushNotificationFCM () {
  const { appLdapUsername, appToken } = useContext( DataContext );

  const { pathname } = useLocation();

  useEffect(
    function initNotifications () {
      console.log( 'pathname', pathname );
      if ( pathname !== '/' ) {
        return;
      }
      console.log( 'Capacitor.getPlatform()', Capacitor.getPlatform() );
      if ( Capacitor.getPlatform() === 'web' ) {
        return;
      }
      console.log( 'appLdapUsername', appLdapUsername );
      if ( !appLdapUsername ) {
        return;
      }
      PushNotifications.checkPermissions()
        .then( ( res ) => {
          if ( res.receive === 'granted' ) {
            doRegister_PNs( appLdapUsername, appToken );
            return;
          }
          PushNotifications.requestPermissions().then( ( res ) => {
            if ( res.receive !== 'denied' ) {
              doRegister_PNs( appLdapUsername, appToken );
              return;
            }
          } );
        } )
        .catch( ( error ) => console.log( 'initNotifications: Fehler:', error ) );
    },
    [ appLdapUsername ]
  );

  return null;
}
